import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { CountUp } from "@/components/CountUp";
import { BrandPatternLayer } from "@/components/BrandPatternLayer";
import { homeStats } from "@/lib/siteConfig";
import { useCmsDocument } from "@/cms/CmsContentProvider";

// Trust / facts band with subtle count-up numbers. Calm, corporate, premium.
export const StatsBand = () => {
  const { locale } = useCmsDocument();
  return (
    <section
      className="relative isolate overflow-hidden bg-[#F1F4F8]/90 py-16 lg:py-24"
      data-testid="home-stats-band"
    >
      <BrandPatternLayer variant="corporate" composition="b" />
      <div className="relative z-10 az-container">
        <SectionHeading
          align="center"
          eyebrow={locale === "ar" ? "أرقام تتحدث عنا" : "Zahlen, die für uns sprechen"}
          title={locale === "ar" ? "ما يمكنكم الاعتماد عليه." : "Worauf Sie sich verlassen können."}
          subtitle={locale === "ar" ? "الموثوقية والشفافية والمتابعة الشخصية هي أساس ثقة عملائنا." : "Verlässlichkeit, Transparenz und persönliche Betreuung – darauf bauen unsere Kundinnen und Kunden."}
          className="mb-12"
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {homeStats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.12} className="h-full">
              <div className="flex h-full flex-col items-center rounded-2xl border border-[#D5DEE8] bg-white px-6 py-8 text-center shadow-[var(--shadow-soft)]">
                <CountUp
                  value={s.value}
                  decimals={s.decimals}
                  suffix={s.suffix}
                  className="font-heading text-5xl font-bold text-[#7A1516] lg:text-6xl"
                />
                <span className="mt-3 font-heading text-xl font-semibold text-[#193D6D]">
                  {s.label}
                </span>
                <span className="mt-1.5 text-sm leading-relaxed text-[#6e7683] [overflow-wrap:anywhere]">
                  {s.hint}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
